export default "__VITE_ASSET__B_e8qiWO__"